import React, { ComponentProps, FC, Fragment } from "react";
import { faMedal, faRobot, faStar, faTrophy } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import dayjs from "dayjs";

import { Avatar } from "@/components";
import { User } from "@/gql/generated/graphql";

type PostUserProps = {
  user: Pick<User, "roles" | "badgeExpires" | "badge" | "name"> &
  ComponentProps<typeof Avatar>["user"];
};

export const PostUser: FC<PostUserProps> = ({ user }) => {
  let nameSuffix;

  if (user.roles.includes("admin")) {
    nameSuffix = <FontAwesomeIcon icon={faStar} />;
  } else if (user.roles.includes("bot")) {
    nameSuffix = <FontAwesomeIcon icon={faRobot} />;
  } else if (user.badgeExpires && dayjs(user.badgeExpires).isAfter(dayjs())) {
    if (user.badge === "WINNER") {
      nameSuffix = <FontAwesomeIcon icon={faTrophy} />;
    } else if (user.badge === "MEDAL") {
      nameSuffix = <FontAwesomeIcon icon={faMedal} />;
    }
  }

  return (
    <Fragment>
      <span className="inline-block relative h-8 aspect-square mr-1">
        <Avatar user={user} className="rounded-tl-md" />
      </span>{" "}
      <span className="group-hover:underline inline-block mx-1">
        {user.name}
      </span>
      {nameSuffix ? <Fragment> {nameSuffix}</Fragment> : null}
    </Fragment>
  );
};
